import { NgModule } from '@angular/core';
import { SessionStorageServiceModule } from '../../shared/session/session-storage/session-storage.module';
import { MortgageSessionDataModel } from './mortgage-session-data.model';
import { MortgageBorrowerDataModule } from './mortgage-borrower-data/mortgage-borrower-data.module';

@NgModule({
  declarations: [
  ],
  imports: [
    SessionStorageServiceModule,
    MortgageBorrowerDataModule
  ],
  providers: [
    MortgageSessionDataModel
  ]
})
export class MortgageSessionDataModule { }
